<template>
	<div class="footer">
		<div class="warper">
			<div class="foot-top  acea-row row-middle">
				<div class="top-left">
					<h3 class="title">公司详情</h3>
					<p v-html="webInfo.company_others"></p>
				</div>
				<div class="top-right">
					<img :src="webInfo.site_character_img" />
					<p>{{ webInfo.site_character_introduction }}</p>
				</div>
			</div>
		</div>
		<div class="foot-bot">
			<div class="warper">
				<a :href="webInfo.site_icp_url" target="_blank">
					©Van Montfort Labs 2019 - 保留所有权利。
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import { getwebInfo } from "../../api";
	export default {
		data() {
			return {
				imgUrl: this.$store.state.imgUrl,
				language: this.$store.state.language,
				webInfo: {},
			};
		},
		mounted: function() {
			let that = this;
			getwebInfo().then((res) => {
				that.webInfo = res.data.result;
			});
		},
	};
</script>

<style lang="less" scoped>
	.footer {
		background: #00091e;
		width: 100%;
		color: #fff;
		line-height: 2;
		.title {
			font-size: 20px;
			font-weight: normal;
			line-height: 1;
			margin-bottom: 20px;
			color: #fff;
		}
		a {
			color: #ccc;
			text-decoration: underline;
		}
		.foot-top {
			padding: 80px 0;
			color: #ccc;
			.top-right {
				margin-left: 120px;
				width: 33.3333%;
				img {
					max-width: 100%;
					margin-bottom: 20px;
				}
			}
		}
		.foot-bot {
			padding: 20px 0;
			border-top: 1px solid #999999;
			a {
				text-decoration: none;
			}
		}
	}

	@media screen and (max-width: 768px) {
	}

	@media screen and (max-width: 640px) {
		.footer {
			.title {
				font-size: 20px;
			}
			a {
				color: #ccc;
				text-decoration: underline;
			}
			.foot-top {
				padding: 40px 0;
				color: #ccc;
				flex-direction: column;
				align-items: flex-start;
				.top-right {
					margin-left: 0;
					width: 100%;
					margin-top: 20px;
					img {
						max-width: 100%;
						margin-bottom: 20px;
					}
				}
			}
			.foot-bot {
				text-align: center;
			}
		}
	}

	@media screen and (max-width: 480px) {
	}
</style>
